module.exports = __webpack_public_path__ + "static/media/heavy_rain.ea4cd441.jpg";